// src/components/common/Tooltip.jsx
import React, { useState } from 'react';
import './Tooltip.css';

function Tooltip({ message, children }) {
  const [isVisible, setIsVisible] = useState(false);

  if (!message) return children; // Don't render tooltip if no message

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="tooltip-box">
          {message}
        </div>
      )}
    </div>
  );
}

export default Tooltip;
